<template>
  <dd-validation-rules-wrapper :name="name" :rules="rules">
    <template #default="validationWrapperProps">
      <validation-provider ref="provider" :name="name" :rules="validationWrapperProps.rules" v-slot="validationProps">
        <dd-input-wrapper
            :rules="validationWrapperProps.rules"
            :title="title"
            :errors="validationProps.errors"
            :name="name"
            :value="value"
            :provider-ref="$refs.provider"
            v-slot="{validateInput}"
        >
          <a-upload
           v-bind="$attrs"
           @change="validateInput"
          >
            <slot>
              <button type="primary" :outline="true">
                <UploadOutlineIcon/>
                Klik om te uploaden
              </button>
            </slot>
          </a-upload>
        </dd-input-wrapper>
      </validation-provider>
    </template>
  </dd-validation-rules-wrapper>
</template>

<script>

export default {
  name: "FileInput.vue",
  emits: ['input'],
  methods: {
    onChange(event) {
      this.$emit('input', event.target.files)
    }
  },
  props: {
    title: String,
    name: String,
    modifyValues: {
      type: Boolean,
      required: false,
      default: true,
    },
    rules: {
      type: [String, Array, Object],
      required: false,
    },
    value: {
      type: [Object, Array]
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
